export class MaklerPaket {

  constructor(id: string, vorgangId : string, lieferung: any, status: string, wert: string, text: string,maklerPaketId:string, gezeichneteProdukte:GezeichneteProdukte[]) {
    this.id = id;
    this.vorgangId = vorgangId;
    this.lieferung = lieferung;
    this.status = status;
    this.wert = wert;
    this.text = text;
    this.maklerPaketId = maklerPaketId;
    this.gezeichneteProdukte=gezeichneteProdukte;
  }

  public lieferung : any;
  public vorgangId : string;
  public id: string;
  public status: string;
  public wert: string;
  public text: string;
  public maklerPaketId: string;
  public gezeichneteProdukte : GezeichneteProdukte[];
}

export class GezeichneteProdukte{
  constructor(bezeichnung: string, wert: string, text: string) {
  this.bezeichnung=bezeichnung;
  this.wert=wert;
  this.text=text;
  }

  public  bezeichnung : string;
  public  wert : string;
  public  text : string;
}
